import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './modules/login-page/login-page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  
   {
    path: 'pda-disburesement/:token',
    loadChildren: () =>
      import('./modules/Disbursment_modules/dis-login/dis-login.module').then((m) => m.DisLoginModule),
    data: { isDisbursement: true }
  },
  {
    path: 'otp',
    loadChildren: () =>
      import('./modules/Disbursment_modules/dis-otp/dis-otp.module').then((m) => m.DisOtpModule),
  },
  {
    path: 'port-agent-form',
    loadChildren: () =>
      import('./modules/Disbursment_modules/port-agent-form/port-agent-form.module').then(
        (m) => m.PortAgentFormModule
      )
  },
  {
    path: 'submit/success',
    loadChildren: () =>
      import('./modules/Disbursment_modules/port-agent-form/pa-form-submit-success-page/pa-form-submit-success-page.module').then((m) => m.PaFormSubmitSuccessPageModule),
  },
  {
    path: 'pdfa',
    loadChildren: () =>
      import('./modules/Disbursment_modules/pdfa/pdfa.module').then((m) => m.PdfaModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/common-logo/common-logo-routing.module').then(
        (m) => m.CommonLogoRoutingModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
